import styled from 'styled-components'
import { Link as LinkR } from 'react-router-dom'

export const NavLogo = styled(LinkR)`
    color: #fff;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%;
    cursor: pointer;

    @media screen and (max-width: 768px) {
        margin-left: -100px;
    }
`
export const SliderBtn = styled(LinkR)`
    cursor: pointer;
`
export const Nav_log = styled(LinkR)`
    cursor: pointer;
`

export const FooterR = styled(LinkR)`
    color: #fff;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%;
    cursor: pointer;
    margin-left: -15px; 
`